import constants from 'core/types'

const initialState = {
  currency0: "eth",
  currency1: "dai",
  token0Amount: "",
  token1Amount: "",
  token0AmountUSD: "",
  token1AmountUSD: "",
  routeUpdated: false
}
export function currencyReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SET_SELECTED_CURRENCIES:   
      return Object.assign({}, state, {
        currency0: action.payload.currency0,
        currency1: action.payload.currency1,
        token0Amount: initialState.token0Amount,
        token1Amount: initialState.token1Amount,
        token0AmountUSD: initialState.token0AmountUSD,
        token1AmountUSD: initialState.token1AmountUSD
      })
    
    case constants.SET_UPDATED_TRADE_ROUTE:
      return Object.assign({}, state, {
        routeUpdated: action.payload.routeUpdated
      })

    case constants.SET_CURRENCY_AMOUNTS:   
      return Object.assign({}, state, {
        token0: action.payload.token0,
        token1: action.payload.token1,
        token0Amount: action.payload.token0Amount,
        token1Amount: action.payload.token1Amount,
        token0AmountUSD: action.payload.token0AmountUSD,
        token1AmountUSD: action.payload.token1AmountUSD
      })
    
    case constants.CLEAR_CURRENCY_AMOUNTS:
      return Object.assign({}, state, {
        token0Amount: initialState.token0Amount,
        token1Amount: initialState.token1Amount,
        token0AmountUSD: initialState.token0AmountUSD,
        token1AmountUSD: initialState.token1AmountUSD
      })
    default:
      return state
  }
}

export default currencyReducer
